import BannerEnd from "./components/BannerEnd";
import BannerSlide from "./components/BannerSlide";
import Category from "./components/Category";
import Product from "./components/Product";
import ProductBanner from "./components/ProductBanner";
import RecentlyViewed from "./components/RecentlyViewed";
import ServicesOffers from "./components/ServicesOffers";
import SmallBanner from "./components/SmallBanner";

import styles from "./HomePage.module.css";

const HomePage = () => {
  return (
    <div className={styles["homepage-container"]}>
      <div className={styles["homepage-flex-container"]}>
        <BannerSlide />
        <Category />
        <Product />
        <SmallBanner />
        <ServicesOffers />
        <ProductBanner />
        <RecentlyViewed />
        <BannerEnd />
      </div>
    </div>
  );
};

export default HomePage;
